import { useContext } from 'react';

import { AppContext } from '../../contexts/AppContext';

const EMPTY_ENTITIES: Record<string, any> = {};

/**
 * Returns the APGL entity dictionary for @-mention resolution in editors.
 *
 * LEGACY: Entities are currently stored in the deprecated AppContext. They should
 * have their own dedicated context/provider, but for now we wrap the access here
 * so consumers don't import AppContext directly. When a proper EntityProvider is
 * created, only this hook needs to change.
 */
export function useEntities(): Record<string, any> {
  const appContext = useContext(AppContext);
  return appContext?.entities ?? EMPTY_ENTITIES;
}
